import { getUserPartcMeetingListFromAuthUserIdApi } from 'api/meeting';
import MeetingDataTable from 'app/components/DataTable/meeting/MeetingDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import config from 'config';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setPageType } from 'stores/meeting';

// tam okuma listesi 368,371
const AttendedMeetings = () => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const params = useParams();
    const param = params.pageType;
    const [pageTitle, setPageTitle] = useState("");
    const [meetingList, setMeetingList] = useState([]);
    const [total, setTotal] = useState(0);
    const [tableQuery, setTableQuery] = useState(null);

    useEffect(() => {
        dispatch(setPageType(param));
    }, [param]);

    useEffect(() => {
        const getAPI = async () => {
            if (!tableQuery) return;

            setLoading(true);
            try {
                const query = {
                    page: tableQuery.page,
                    limit: tableQuery.limit,
                    q: tableQuery.q,
                    sortBy: tableQuery.sortBy,
                    sortOrder: tableQuery.sortOrder,
                    pageType: param,
                    ...tableQuery.filters,
                };

                const res = await getUserPartcMeetingListFromAuthUserIdApi(query);
                setMeetingList(res.data || []);
                setTotal(res.total || 0);

                const cardTitle = config.dashboardCarsInfo.find(card => card.name === param);
                setPageTitle(cardTitle !== undefined ? cardTitle.title : "Toplantı Listesi");
            } catch (error) {
                console.error("API Hatası: ", error);
            } finally {
                setLoading(false);
            }
        };

        getAPI();
    }, [param, tableQuery]);

    const columnData = [
        { id: 'inst', align: 'left', disablePadding: false, label: "Kurum" },
        { id: 'unit', align: 'left', disablePadding: true, label: "Kurul/Kol/Komisyon" },
        { id: 'meetingNo', align: 'left', disablePadding: false, label: "Toplantı No" },
        { id: 'pdate', align: 'left', disablePadding: true, label: "Tarih" },
        { id: 'adminUserId', align: 'center', disablePadding: false, label: "Toplantı Yöneticisi" },
        { id: 'decisionCount', align: 'left', disablePadding: true, label: "Karar Sayısı" },
        { id: 'userParticipantList', align: 'center', disablePadding: true, label: "Üyeler / Katılımcılar" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler" }
    ];

    return (
        <React.Fragment>
            <>
                <LoadingPopUp open={loading} />
                <MeetingDataTable
                    key={param || 'attended'}
                    column={columnData}
                    pageTitle={pageTitle}
                    mainData={meetingList}
                    listTotal={total}
                    onQueryChange={setTableQuery}
                />
            </>
        </React.Fragment>
    );
};

export default AttendedMeetings;
